<div class="form-inline">
  <button
    *ngIf="!inputPrice"
    nbButton
    fullWidth
    outline
    shape="semi-round"
    status="primary"
    size="small"
    (click)="openInputPrice()"
  >
    <span style="font-size: 1.125rem">
      {{ renderValue | number }}
    </span>
  </button>

  <nb-form-field *ngIf="inputPrice" fullWidth>
    <!-- <label nbPrefix [ngClass]="renderCss">{{ renderValue | number }}</label> -->
    <button nbPrefix nbButton ghost (click)="closeInputPrice()" status="danger">
      <nb-icon icon="close-outline"> </nb-icon>
    </button>

    <input
      type="text"
      nbInput
      fullWidth
      shape="semi-round"
      class="form-control"
      [placeholder]="placeholder"
      [status]="renderValue > 0 ? 'primary' : 'danger'"
      [(ngModel)]="inputValue"
      (change)="onChange()"
      (keydown.enter)="onEnter()"
      #elValue
    />

    <!-- <label nbSuffix [ngClass]="renderCss">{{ renderValue | number }}</label> -->
    <button nbSuffix nbButton ghost (click)="onEnter()" status="primary">
      <nb-icon icon="save-outline"> </nb-icon>
    </button>
  </nb-form-field>
</div>
